<template>
  <div class="checkout">
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />

    <v-container class="checkout-title">
      <CategoryTitle :category="category" :showOnMobile="true" />
    </v-container>
    <v-container :fluid="$vuetify.breakpoint.xsOnly" class="pt-0">
      <v-row>
        <v-col cols="12">
          <ResponseMessage :response="response" />
        </v-col>
        <v-col cols="12" class="py-0">
          <CheckoutConfirmEmail
            v-if="!cart.user.profile.confirmed"
            :key="cart.refreshTime"
            @sendEmail="sendActivationMail"
          />
        </v-col>
        <v-col cols="12" md="9" class="pt-0">
          <v-row justify="space-between" class="mb-3 px-3 px-sm-0">
            <v-col cols="12" order-sm="4" class="px-0 px-md-3">
              <CartItemList
                class="items-list"
                :isCheckout="true"
                :full="$vuetify.breakpoint.xs"
                itemListName="Order"
              />

              <gift-list
                v-if="giftCertificates.length > 0"
                :mode="'checkout'"
                :title="$t('checkout.giftCodeSubtitle')"
                :giftList="giftCertificates"
                @reload="loadGiftCertificates"
              />

              <v-alert
                v-if="error"
                type="error"
                border="left"
                transition="v-fab-transition"
              >
                {{ error }}
              </v-alert>
            </v-col>
            <v-col cols="12" sm="4" order-sm="1">
              <CartInfoServiceCard
                :shippingAddress="cart.shippingAddress"
                :editable="editableAddress"
                @edit="openAddressSelector"
                :isCheckout="true"
                class="secondary lighten-2 w-100"
              />
            </v-col>
            <v-col cols="12" sm="4" order-sm="2">
              <CartInfoAddressCard
                :shippingAddress="cart.shippingAddress"
                :editable="editableAddress"
                @edit="openAddressSelector"
                :isCheckout="true"
                class="secondary lighten-2 w-100"
              />
            </v-col>
            <v-col cols="12" sm="4" order-sm="3">
              <CartInfoTimeslotCard
                :shippingAddress="cart.shippingAddress"
                :timeslot="cart.timeslot"
                :editable="editableTimeslot"
                @edit="openTimeslotSelector"
                :isCheckout="true"
                class="secondary lighten-2 w-100 cart-info-timeslot-card"
                :value="timeslot"
              />
            </v-col>
            <v-col cols="12" order-sm="5">
              <div
                class="checkout-actions d-flex justify-space-between align-center flex-column flex-md-row"
              >
                <div
                  class="d-flex flex-column flex-sm-row mb-2 mb-md-0 w-100 w-sm-auto justify-space-between justify-md-start"
                >
                  <v-btn
                    color="primary"
                    class="mr-0 mr-sm-2 mb-2 mb-sm-0"
                    x-large
                    depressed
                    outlined
                    @click="addAllToFavorites"
                  >
                    <span>{{ $t("checkout.addToListBtn") }}</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    x-large
                    outlined
                    depressed
                    @click="emptyCartConfirm"
                  >
                    <span>{{ $t("checkout.emptyCartBtn") }}</span>
                  </v-btn>
                </div>
                <div
                  class="d-flex flex-column flex-sm-row justify-space-between justify-md-end w-100 w-sm-auto"
                >
                  <v-btn
                    color="secondary primary--text"
                    class="mr-0 mr-sm-2 mb-2 mb-sm-0"
                    x-large
                    depressed
                    :disabled="
                      profileLevel < minProfileLevel || cart.totalItems == 0
                    "
                    @click="fastPayment"
                  >
                    <span>{{ $t("checkout.fastPaymentBtn") }}</span
                    ><v-icon small class="ml-1">$fastSearch</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    x-large
                    depressed
                    :disabled="
                      profileLevel < minProfileLevel || cart.totalItems == 0
                    "
                    :loading="loading"
                    @click="goToPayment"
                  >
                    <span>{{ $t("checkout.goToPaymentBtn") }}</span>
                  </v-btn>
                </div>
              </div>
              <category-block
                :target="category"
                :container="false"
                position="position2"
                class="category-block category-block-2"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="pt-0">
          <div class="mb-3 px-3 px-sm-0">
            <CheckoutCompleteProfile v-if="profileLevel < minProfileLevel" />

            <CheckoutSummary
              :orderCart="cart"
              @removeGiftCode="loadGiftCertificates"
            />

            <DeliveryFee class="mt-5" :showList="true" />

            <GiftCode
              class="mt-5"
              v-if="!get(category, 'metaData.template_model.HIDE_GIFT')"
              :giftCertificates="giftCertificates"
              @add="loadGiftCertificates"
              @remove="loadGiftCertificates"
            />
            <v-btn
              v-if="showPersonalCoupon"
              color="secondary primary--text"
              class="mt-5 w-100"
              x-large
              depressed
              :disabled="profileLevel < minProfileLevel || cart.totalItems == 0"
              @click="showPersonalCouponDialog"
            >
              Applica i tuoi bolloni
            </v-btn>
            <v-btn
              color="secondary primary--text"
              class="mt-5 w-100"
              x-large
              depressed
              :disabled="profileLevel < minProfileLevel || cart.totalItems == 0"
              @click="fastPayment"
            >
              <span>{{ $t("checkout.fastPaymentBtn") }}</span
              ><v-icon small class="ml-1">$fastSearch</v-icon>
            </v-btn>
            <v-btn
              class="mt-5 w-100"
              color="primary"
              x-large
              :block="$vuetify.breakpoint.xs"
              depressed
              :disabled="profileLevel < minProfileLevel || cart.totalItems == 0"
              :loading="loading"
              @click="goToPayment"
            >
              <span>{{ $t("checkout.goToPaymentBtn") }}</span>
            </v-btn>
            <category-block
              :target="category"
              :container="false"
              position="position3"
              class="category-block category-block-3"
            />
            <category-block
              :target="category"
              :container="false"
              position="position4"
              class="category-block category-block-4"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style lang="scss">
.checkout {
  .cart-info-timeslot-card {
    .value {
      text-transform: uppercase;
    }
  }
  .privacy-check {
    a {
      color: var(--v-default-base) !important;
      font-weight: bold;
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
      .checkout-title {
        h1 {
          font-size: 24px !important;
        }
      }
    }
  }
  .qty-wrap {
    max-width: 160px;
  }
}
</style>
<script>
import CheckoutSummary from "@/components/cart/CheckoutSummary.vue";
import CheckoutCompleteProfile from "@/components/cart/CheckoutCompleteProfile.vue";
import CheckoutConfirmEmail from "@/components/cart/CheckoutConfirmEmail.vue";
import GiftCode from "@/components/gift/GiftCode.vue";
import CartInfoServiceCard from "@/components/cart/CartInfoServiceCard.vue";
import CartInfoAddressCard from "@/components/cart/CartInfoAddressCard.vue";
import CartInfoTimeslotCard from "@/components/cart/CartInfoTimeslotCard.vue";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import FastPayment from "@/components/cart/FastPayment.vue";
import ListSelector from "@/components/lists/ListSelector.vue";
import CartItemList from "@/components/cart/CartItemList.vue";
import DeliveryFee from "@/components/delivery/DeliveryFee.vue";
import ResponseMessage from "@/components/ResponseMessage.vue";

import AnalyticsService from "~/service/analyticsService";
import ListService from "~/service/listService";
import RegistrationService from "~/service/userService";
import PersonalCouponService from "@/service/personalCouponService";
import GiftProductSelector from "@/components/gift/GiftProductSelector.vue";

import login from "~/mixins/login";
import cartInfo from "~/mixins/cartInfo";
import categoryMixins from "~/mixins/category";

import { forEachCartItem } from "~/service/ebsn.js";
import { mapActions, mapState, mapGetters } from "vuex";

// import forEach from "lodash/forEach";
// import cloneDeep from "lodash/cloneDeep";

import get from "lodash/get";
import GiftList from "@/components/gift/GiftList.vue";
// import CategoryBlock from "@/components/categoryBlock/CategoryBlock.vue";

export default {
  name: "Checkout",
  mixins: [login, cartInfo, categoryMixins],
  components: {
    CategoryTitle,
    CheckoutSummary,
    GiftCode,
    CheckoutCompleteProfile,
    CheckoutConfirmEmail,
    CartInfoServiceCard,
    CartInfoAddressCard,
    CartInfoTimeslotCard,
    CartItemList,
    DeliveryFee,
    ResponseMessage,
    GiftList
    //,
    // CategoryBlock
  },
  data() {
    return {
      error: null,
      loading: false,
      response: {},
      minProfileLevel: global.config.minProfileLevel,
      giftCertificates: [],
      emailKey: 1,
      packages: true,
      selectedOptions: {},
      iosMobile: false,
      showPersonalCoupon: false,
      dialogInstance: null
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      profileLevel: "cart/profileLevel"
    }),
    editableAddress() {
      return !(this.cart.cartStatusId == 7);
    },
    editableTimeslot() {
      return !(this.$route.name == "Payment");
    }
  },

  methods: {
    get: get,
    ...mapActions({
      lockCart: "cart/lockCart",
      emptyCart: "cart/emptyCart",
      removeGiftCode: "cart/removeGiftCode",
      loadCart: "cart/loadCart",
      getCart: "cart/getCart"
    }),
    sendActivationMail() {
      this.response = {};
      let _this = this;
      RegistrationService.registrationResendEmail(this.cart.user.email).then(
        function(data) {
          _this.response = data.response;
        },
        function(response) {
          _this.response = response;
        }
      );
    },
    async loadGiftCertificates() {
      //this.autoAssignedGifts = await userService.listGiftCertificate("auto");

      let giftCertificates = await RegistrationService.listGiftCertificate(
        "list"
      );
      var manualGiftCertificates = await RegistrationService.listGiftCertificate(
        "manual"
      );

      this.giftCertificates = [
        ...giftCertificates,
        ...manualGiftCertificates
      ].filter(giftCertificate => {
        // if (giftCertificate.giftAdjustmentType.giftAdjustmentTypeId == 21) {
        //   //hide refund
        //   return false;
        // }
        //check user gift
        let hasUserGift = [];
        if (giftCertificate.userGiftCertificates?.length > 0) {
          hasUserGift = giftCertificate.userGiftCertificates.filter(
            userGiftCertificate => {
              return !userGiftCertificate.orderId;
            }
          );
        }
        return !!giftCertificate.giftCode || hasUserGift.length > 0;
      });
    },
    async fastPayment() {
      let _this = this;
      let res = await _this.$dialog.show(FastPayment, {
        waitForResult: true,
        width: 500
      });
      if (res) {
        // let items = [];
        // forEachCartItem(_this.cart, function(item) {
        //   items.push(item);
        // });
        // await ListService.addProductsToList(res.listId, items);
      }
    },
    async addAllToFavorites() {
      let _this = this;
      let res = await _this.$dialog.show(ListSelector, {
        waitForResult: true,
        fullscreen: _this.$vuetify.breakpoint.smAndDown,
        width: 300
      });
      if (res) {
        let items = [];
        forEachCartItem(_this.cart, function(item) {
          items.push(item);
        });
        await ListService.addProductsToList(res.listId, items);
      }
    },
    async emptyCartConfirm() {
      if (this.cart.totalItems > 0) {
        let res = await global.vm.$dialog.confirm({
          text: global.vm.$t("message.emptyCart")
        });
        if (res) {
          this.emptyCart();
        }
      }
    },
    async goToPayment() {
      let _this = this;
      _this.loading = true;
      try {
        if (await this.needLogin("addtocart")) {
          if (await this.needAddress()) {
            if (await this.needTimeslot()) {
              await _this.lockCart();
              _this.$router.push({
                name: "Payment"
              });
            }
          }
        }
      } catch (err) {
        await this.getCart();
        await this.needTimeslot();
        _this.error = err.message;
      } finally {
        _this.loading = false;
      }
    },
    async showPersonalCouponDialog() {
      this.dialogInstance = await this.$dialog.show(GiftProductSelector, {
        title: "Scegli ii proodtti a cui appliicare i tuoi bolloni",
        waitForResult: false,
        fullscreen: this.$vuetify.breakpoint.smAndDown
      });
      const result = await this.dialogInstance.wait();
      if (result) {
        await this.loadCart();
      }
      return result;
    },
    checkOsx() {
      var userAgent = [];
      var version = [];
      var versionNumber = 0;
      if (navigator.userAgent.indexOf("iPhone") > -1) {
        userAgent = navigator.userAgent.split(" ");
        userAgent.filter(ua => {
          if (ua.indexOf("Version/") > -1) {
            version = ua.split("/");
          }
        });
        versionNumber = parseFloat(version[1]);
        if (version[0] == "Version") {
          if (versionNumber < 15) {
            this.iosMobile = true;
          } else {
            this.iosMobile = false;
          }
        } else {
          this.iosMobile = false;
        }
      }
    }
  },
  async mounted() {
    // if (!this.cart.user.profile.confirmed) {
    //   this.sendActivationMail();
    // }
    global.EventBus.$on("resetAlertMessage", () => {
      if (this.error) {
        this.error = false;
      }
    });
    AnalyticsService.viewProducts(this.cart.cartItems, this.itemListName, 0);
    // AnalyticsService.beginCheckout(this.cart);
    AnalyticsService.viewCart(this.cart);
    this.checkOsx();
    this.loadGiftCertificates();
    let personalCoupon = await PersonalCouponService.checkCoupon();
    if (
      personalCoupon &&
      personalCoupon.gift_certificates &&
      personalCoupon.gift_certificates.length > 0
    ) {
      this.showPersonalCoupon = true;
      await this.getCart();
    }
  }
};
</script>
